import PropTypes from 'prop-types';
import React from 'react';

import { SentryService } from '../../modules/infra/observability/sentry';

class ErrorBoundary extends React.Component {


  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    // You can also log the error to an error reporting service
    SentryService.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return this.props.children;
  }
}

const MFWrapper = props => (
  <React.Suspense fallback={null}>
    <ErrorBoundary>
      {props.children}
    </ErrorBoundary>
  </React.Suspense>
);

MFWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MFWrapper;
